import { $http, buildHeaders } from "./index";

//获取验证码
export const captcha = () => {
  return $http.get("/admin/Login/captcha", {
    headers: {
      unAuth: true,
    },
  });
};

//登录验证
export const judgeLogin = (data) => {
  return $http.post("/admin/Login/doLogin", data, {
    headers: {
      ...buildHeaders(3, "正在验证登录信息，请稍后……"),
      unAuth: true,
    },
  });
};

//获取登录用户信息
export const home_getuser = () => {
  return $http.get("/admin/Admin/read?id=", {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//修改当前登录用户
export const home_setuser = (data) => {
  return $http.post("/admin/Admin/save", data, {
    headers: buildHeaders(3),
  });
};

//获取数据字典类别
export const dictionarycate_list = () => {
  return $http.get("/admin/DictionaryCate/index", {
    limit: 0,
    sort_field: "name",
  });
};

//获取数据字典列表
export const dictionary_list = (params) => {
  return $http.get("/admin/Dictionary/index", { params });
};

//获取数据字典详情
export const dictionary_detail = (id) => {
  return $http.get("/admin/Dictionary/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加数据字典
export const dictionary_add = (data) => {
  return $http.post("/admin/Dictionary/add", data, {
    headers: buildHeaders(3),
  });
};

//修改数据字典
export const dictionary_edit = (data) => {
  return $http.post("/admin/Dictionary/edit", data, {
    headers: buildHeaders(3),
  });
};

//数据字典启停
export const dictionary_qt = (data) => {
  return $http.post("/admin/Dictionary/updateStatus", data, {
    headers: buildHeaders(3),
  });
};

//删除数据字典
export const dictionary_delete = (id) => {
  return $http.post(
    "/admin/Dictionary/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取登录日志
export const loginlog_list = (params) => {
  return $http.get("/admin/LoginLog/index", { params });
};

//获取通知公告列表
export const adminnotice_list = (params) => {
  return $http.get("/admin/AdminNotice/index", { params });
};

//获取通知公告详情
export const adminnotice_detail = (id) => {
  return $http.get("/admin/AdminNotice/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加通知公告
export const adminnotice_add = (data) => {
  return $http.post("/admin/AdminNotice/add", data, {
    headers: buildHeaders(3),
  });
};

//修改通知公告
export const adminnotice_edit = (data) => {
  return $http.post("/admin/AdminNotice/edit", data, {
    headers: buildHeaders(3),
  });
};

//通知公告启停
export const adminnotice_qt = (data) => {
  return $http.post("/admin/AdminNotice/updateStatus", data, {
    headers: buildHeaders(3),
  });
};

//删除通知公告
export const adminnotice_delete = (id) => {
  return $http.post(
    "/admin/AdminNotice/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取客户池列表
export const customerpool_list = (params) => {
  return $http.get("/admin/CustomerPool/index", { params });
};

//获取签约单位详情
export const customerpool_detail = (id) => {
  return $http.get("/admin/CustomerPool/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//导入客户
export const customerpool_import = (data) => {
  return $http.post("/admin/CustomerPool/import", data, {
    headers: buildHeaders(3),
  });
};

//删除客户池
export const customerpool_delete = (id) => {
  return $http.post(
    "/admin/CustomerPool/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取待办事项
export const home_todolist = (params) => {
  return $http.get("/admin/AdminTodo/index", { params });
};

//获取通知公告
export const home_noticelist = (params) => {
  return $http.get("/admin/AdminNotice/notice", { params });
};
